(() => {
 function init(root = document) {
    root.querySelectorAll('[data-veyro-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const track = gallery.querySelector('.veyro-gallery__track');
      const count = track.children.length;
      const position = () => Math.round(track.scrollLeft / track.clientWidth);
      const status = () => {
        const index = position();
        gallery.querySelector('[data-gallery-count]').textContent = `${index + 1} / ${count}`;
        gallery.querySelector('[data-gallery-prev]').disabled = index === 0;
        gallery.querySelector('[data-gallery-next]').disabled = index >= count - 1;
      };
      const move = amount => track.scrollTo({left: Math.max(0, Math.min(count - 1, position() + amount)) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      gallery.querySelector('[data-gallery-prev]').addEventListener('click', () => move(-1));
      gallery.querySelector('[data-gallery-next]').addEventListener('click', () => move(1));
      track.addEventListener('scroll', status, {passive:true});
      track.addEventListener('keydown', event => { if (['ArrowLeft','ArrowRight'].includes(event.key)) { event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1); } });
      status();
    });
  }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
 document.addEventListener('shopify:section:load', event => init(event.target));
})();
